import React, { useEffect, useMemo, memo, useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Loader from '@components/common/Loader/newLoaderModal';
import { toggleTheme } from '@reducers/theme';
import { getObjectValue } from '../../../utility/utills';
import cn from 'classnames';
import styles from './modal.module.css';

const FullWithModal = ({
  isOpen,
  children,
  customClass,
  customClass2,
  loading,
  style,
}) => {
  const dispatch = useDispatch();
  const serverAppTheme = useSelector(state => state.theme.serverAppTheme);

  const getTheme = useMemo(() => {
    return getObjectValue(
      () => JSON.parse(window.sessionStorage.getItem('auth')).serverAppTheme
    );
  }, []);

  useEffect(() => {
    dispatch(toggleTheme(getTheme));
  }, [dispatch, getTheme]);

  const modalBgStyle = useMemo(
    () => ({ background: serverAppTheme?.modal_bg }),
    [serverAppTheme?.modal_bg]
  );

  if (!isOpen) return null;

  return (
    <div className="h-auto">
      {loading && <Loader />}
      <div
        className={cn(
          'modal',
          isOpen ? 'fade show d-block' : 'fade',
          customClass,
          styles.popupFlow
        )}
        style={modalBgStyle}
      >
        <div className={cn(customClass2)} role="document">
          <div style={style}>{children}</div>
        </div>
      </div>
    </div>
  );
};

export default memo(FullWithModal);
